angular.module 'app'
.controller 'TemplateLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
